<template>
  <div class="home">
    <HomeMain/>
  </div>
</template>

<script>
import HomeMain from '@/components/HomeMain'

export default {
  components: {
    HomeMain
  }
}
</script>
